export default __webpack_public_path__ + "static/media/wave.c69fd3dd.svg";